import gql from "graphql-tag";

export const m_SetProjectBillingPlan = gql`
  mutation SetProjectBillingPlan($input: SetProjectBillingPlanRequestInput) {
    SetProjectBillingPlan(input: $input) {
      success
    }
  }
`;
